import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfigProvider } from "antd";
import jaJP from "antd/locale/ja_JP";

import { StyledEngineProvider } from "@mui/material/styles";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux"; 
const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <Provider store={store}>
    <ConfigProvider locale={jaJP}>
      <StyledEngineProvider injectFirst>
        <App />
        <ToastContainer className="custom-react-toastify" />
      </StyledEngineProvider>
    </ConfigProvider>
  </Provider>
);

reportWebVitals();
